<template>
  <div>
    <div id="login-banner" class="flex justify-center lg:pt-20 md:pt-12 pt-4">
      <img
        data-v-61dd7a3d=""
        id="rhul-logo"
        alt="rhul-logo"
        src="https://www.royalholloway.ac.uk/images/logoRoyalHolloway2x.png"
      />
    </div>
    <br />
    <div>
      <h1
        id="login-title"
        class="font-semibold text-lg text-center text-white py-1"
      >
        Module Selector
      </h1>
      <h1
        id="login-title2"
        class="font-semibold text-lg text-center text-rhulorange mb-3"
      >
        Computer Science
      </h1>
    </div>
    <div
      id="login-box"
      class="
        bg-gray-50
        md:w-1/3
        xl:w-1/4
        w-1/2
        mt-7
        h-1/3
        m-auto
        rounded
        p-5
        animate-fade-in-down
      "
    >
      <script type="text/x-template" id="modal-template">
        <transition name="modal">
          <div class="modal-mask ">
            <div class="modal-wrapper">
              <div class="modal-container">
                <div class="modal-header">
                  <slot name="header">
                    Error
                  </slot>
                </div>
                <div class="modal-body">
                  <slot name="body">
                    <span id = 'message'></span>
                    <button
                      class="modal-default-button"
                      @click="$emit('close')"
                    >
                      OK
                    </button>
                  </slot>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </script>

      <div class="flex justify-center w-full py-2">
        <form @submit.prevent="handleSubmit">
          <label class="py-1 font-semibold" for="email">Email</label>
          <div class="group flex mb-3">
            <div class="flex">
              <i class="fas fa-envelope pt-3 pr-3 text-xl"></i>
            </div>
            <input
              id="email"
              type="email"
              v-model="email"
              required
              autofocus
              class="
                w-full
                bg-transparent
                border-black border-t-0 border-r-0 border-l-0 border-b-2
                focus:border-rhulorange
                hover:border-rhulorange
                transition
                0.15s
                focus:ring-transparent
              "
            />
          </div>
          <div class="inline border-none">
            <label class="py-2 font-semibold" for="password">Password</label>
            <div class="flex my-1">
              <div class="flex">
                <i class="fas fa-lock pt-3 pr-3 text-xl"></i>
              </div>
              <input
                id="password"
                type="password"
                v-model="password"
                required
                class="
                  w-full
                  bg-transparent
                  border-black border-t-0 border-r-0 border-l-0 border-b-2
                  focus:border-rhulorange
                  hover:border-rhulorange
                  transition
                  0.15s
                  focus:ring-transparent
                "
              />
            </div>
          </div>
          <div>
            <input
              id="login-button"
              type="submit"
              value="Login"
              @click="handleSubmit"
              class="
                bg-orange-500
                text-white
                p-1
                my-6
                w-full
                hover:bg-orange-600
                transition
                0.5s
                rounded
              "
            />
          </div>
          <div>
            <p class="w-full text-xs text-red-500 animate-fade-in-down">
              {{ errorMsg }}
            </p>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<style scoped></style>

<script>

export default {
  data() {
    return {
      email: '',
      password: '',
      errorMsg: '',
      ldapRegistrations: [],
    };
  },
  methods: {
    /**
     * Gets the LDAP registrations of the user, if any exist.
     * Then put in local storage
     */
    getLDAPRegistrations() {
      this.$axios
        .post(
          `${process.env.VUE_APP_API_URL}/get_ldap_registrations`,
          {
            email: localStorage.getItem('user'),
            jwt: localStorage.getItem('jwt'),
          },
        )
        .then((response) => {
          const temp = response.data;
          this.ldapRegistrations = temp.success ? temp.data : [];
          localStorage.setItem('ldapRegistrations', this.ldapRegistrations);
        });
    },

    /**
     * Authenticates the user.
     * Username and password are sent to server, checked,
     * and returns webtokens if valid.
     * User is then sent to the appropriate page.
     *
     * @param {click} e - On-click event handler.
     * @arg {response} r - A response argument from server.
     */
    handleSubmit(e) {
      console.log('Getting login details');
      e.preventDefault();

      if (this.password.length > 0 && this.email.length > 0) {
        fetch(
          `${process.env.VUE_APP_API_URL}/login`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              'email': this.email,
              'password': this.password,
            }),
          },
        )
          .then((r) => {
            return r.json();
          })
          .then((r) => {
            console.log(r);
            localStorage.setItem('user', r.user);
            localStorage.setItem('whenCreated', r.whenCreated);
            localStorage.setItem('name', r.name);
            localStorage.setItem('prog', r.prog);
            localStorage.setItem('jwt', r.token);
            localStorage.setItem('student', r.student);
            localStorage.setItem('office', Boolean(r.office));
            localStorage.setItem('stage', r.stage);
            localStorage.setItem('sn', r.studentNumber);
            localStorage.setItem('admin', r.admin);

            // Might need to change back to r.ldapRegistrations if this
            // doesn't work with ldap_data
            localStorage.setItem('ldapRegistrations', []);
            // If user has a webtoken, send them to the correct page.
            if (localStorage.getItem('jwt') != null) {
              this.getLDAPRegistrations();
              this.$router.push(['student', 'office'].find((e) => r[e]));
            }
          })
          .catch((error) => {
            this.errorMsg = 'Incorrect Username and/or Password!';
            console.error(error);
          });
      } else {
        this.errorMsg = 'Please enter Username and Password!';
      }
    },
  },
};
</script>
